
function isArray(inArray) {
    return inArray !== undefined && inArray !== null && inArray.constructor.name === "Array" && inArray !== [];
}

export {
    isArray
}